import { api } from "@/lib/api"
import type { DEB_ID_DETAILS } from "@/types/form-types"
import { useMutation } from "@tanstack/react-query"

export function useDebID() {
	const useDebIDValidate = (universityId: string, application_id: string) => {
		return useMutation({
			mutationFn: async (payload: {
				deb_id: string
				application_id: string
				field_id: string
				abc_field_id?: string
				name_field_id?: string
				mobile_field_id?: string
				gender_field_id?: string
				dob_field_id?: string
				email_field_id?: string
			}) => {
				const verifiedBy =
					window.__DF_USER__?.type === "L1_DOCUMENT_VERIFIER" ||
					window.__DF_USER__?.type === "L2_DOCUMENT_VERIFIER"
						? window.__DF_USER__.user_id
						: application_id
				const { data } = await api.post<DEB_ID_DETAILS>(
					`/universities/${universityId}/verify-deb?verified_by=${verifiedBy}`,
					payload,
				)

				return data
			},
			mutationKey: ["validate-deb-id", universityId],
		})
	}

	return {
		useDebIDValidate,
	}
}
